import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Product } from '../types/product.type';
import { ADMIN_PRODUCTS_API_PATHS } from '../constants/products-api-paths.constants';

type UseRestoreProductResult = {
  restoreProduct: (productId: string) => Promise<Product | null>;
  isSubmitting: boolean;
};

export function useRestoreProduct(): UseRestoreProductResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreProduct = async (productId: string): Promise<Product | null> => {
    setIsSubmitting(true);

    try {
      const restoredProduct = await HttpClient.post<Product>(ADMIN_PRODUCTS_API_PATHS.RESTORE_PRODUCT(productId));

      enqueueSnackbar('Produit restauré', { variant: 'success' });
      return restoredProduct;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la restauration du produit'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreProduct, isSubmitting };
}
